import groq from "groq";
import { translatedFieldQuery } from "@pkg/sanity-utils/translatedFieldQuery";
import { generalLink } from "@pkg/sanity-utils/linkQueries";

/**
 * When loading this Block in a modular content block, the following fields will be loaded.
 * Ensure all fields used in your block are loaded below.
 * _type and _key will always be included, and do not need to be specified below.
 *
 * The fields are loaded like so:
 *   _type == "YOUR_BLOCK" => {
 *     _type,
 *     _key,
 *     YOUR_FIELDS...,
 *   }
 */

const statisticFields = groq`
...,
`;

export const blockStatisticsFields = groq`
   ...,
   "button": coalesce(button[][0] {
      ...,
      link {
        ${generalLink}
      },
  }, false),
   "items": coalesce(items[] {
      _type=="onetime" => {${statisticFields}},
      _type=="existing"=> @->{
        icon,
        ${translatedFieldQuery('prefix')},
        ${translatedFieldQuery('stat')},
        ${translatedFieldQuery('suffix')},
        ${translatedFieldQuery('context')},
        ${translatedFieldQuery('content')},
        ${translatedFieldQuery('source')},
      }
    }, [])
 `;
